import React from "react";
import PropTypes from "prop-types";

const Template = props => (
  <div>
    <section className="hero sticky-header">
      <div className="hero-block">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">{props.title}</h1>
            <div className="content is-medium">
              <h3 className="subtitle">{props.subtitle}</h3>
              {props.notes && <p>{props.notes}</p>}
            </div>
          </div>
        </div>
      </div>
    </section>

    <div className="container is-widescreen poll-container">
      <section className="section poll-section">
        <div className="box content is-medium">{props.children}</div>
        {(!props.navigationLeft.length > 0 ||
          props.navigationRight.length > 0) && (
          <div className="box">
            <div className="columns">
              <div className="column has-text-left navigation-button-left">
                {props.navigationLeft &&
                  props.navigationLeft.map(element => element)}
              </div>
              <div className="column has-text-right navigation-button-right">
                {props.navigationRight &&
                  props.navigationRight.map(element => element)}
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  </div>
);

Template.propTypes = {
  notes: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  navigationLeft: PropTypes.arrayOf(PropTypes.node),
  navigationRight: PropTypes.arrayOf(PropTypes.node),
  title: PropTypes.node,
  subtitle: PropTypes.node
};

Template.defaultProps = {
  notes: null,
  navigationLeft: [],
  navigationRight: [],
  title: null,
  subtitle: null
};

export default Template;



// WEBPACK FOOTER //
// ./src/components/pages/Template.js